module.exports = __webpack_public_path__ + "static/media/0102carousel-notes.8a776561.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0102carousel-notes.jpg
// module id = 388
// module chunks = 0